import React, { createContext, useContext } from 'react';
import {
  ProgressPortraitAction,
  useProgressPortrait,
} from '../hook/useProgressPortrait';
import { useUserInfo } from '@xolv-mybrightlink/common';
import { ProgressPortraitStore } from '../hook/ProgressPortraitStore';

type ProgressPortraitProviderProps = {
  children: React.ReactNode;
};
const ProgressPortraitContext = createContext<{
  store: ProgressPortraitStore;
  dispatch: React.Dispatch<ProgressPortraitAction>;
} | null>(null);

export const ProgressPortraitProvider = ({
  children,
}: ProgressPortraitProviderProps) => {
  const { patients } = useUserInfo();
  const { store, dispatch } = useProgressPortrait(patients);
  return (
    <ProgressPortraitContext.Provider value={{ store, dispatch }}>
      {children}
    </ProgressPortraitContext.Provider>
  );
};

export const useProgressPortraitContext = () => {
  const context = useContext(ProgressPortraitContext);
  if (context == null) {
    throw new Error('ProgressPortrait is not in the context');
  }
  return context;
};
